<template>
  <Banner class="GameProfile">
    <template slot="header" v-if="replay.id">
      <h1>{{ replay.name }}</h1>

      <template v-if="replay.flags & CTS.REPLAY_HAS_MAP_PROFILE && false">
        <router-link
          :to="{
            name: replay.map
          }"
        >
          <Icon
            src="/assets/icons/map.png"
            :size="55"
            v-tooltip="{
              content: replay.data.game.map,
              targetClasses : [ 'tooltip', 'tooltip-nowrap' ]
            }"
          >{{ replay.map }}</Icon>
        </router-link>
      </template>

      <template v-else>
        <Icon
          src="/assets/icons/map.png"
          :size="55"
          v-tooltip="{
            content: replay.data.game.map,
            classes : [ 'tooltip', 'tooltip-nowrap' ]
          }"
        >{{ replay.map }}</Icon>
      </template>
    </template>

    <template slot="caption">
      <Loader
        :url="urlReplay"
        :model="Replay"
        v-model="replay"
      >
        <Params
          :replay="replay"
          slot="result"
        ></Params>
      </Loader>
    </template>

    <template v-if="replay.id">
      <template slot="tabs">
        <Tab to="/">Overview</Tab>

        <Tab
          to="/results"
          :disabled="! (replay.flags & CTS.REPLAY_HAS_RESULTS)"
          v-tooltip="{
            content: 'This game does not have any results.',
            classes: [ replay.flags & CTS.REPLAY_HAS_RESULTS ? 'd-none' : '' ]
          }"
        >Results</Tab>

        <Tab
          to="/mmd"
          :disabled="! (replay.flags & CTS.REPLAY_HAS_W3MMD)"
          v-tooltip="{
            content: 'This game does not have any custom map data.',
            classes: [ replay.flags & CTS.REPLAY_HAS_W3MMD ? 'd-none' : '' ]
          }"
        >MMD</Tab>

        <Tab
          to="/events"
          :disabled="!replay.hasEvents ()"
          v-tooltip="{
            content: 'Events are only supported by maps that have implemented custom event logging.',
            classes: [ replay.hasEvents () ? 'd-none' : '' ]
          }"
        >Events</Tab>

        <Tab
          to="/chat"
          :disabled="!replay.hasChat ()"
          v-tooltip="{
            content: 'This game has an empty chatlog.',
            classes: [ replay.hasChat () ? 'd-none' : '' ]
          }"
        >Chat</Tab>

        <div class="Banner-controls">
          <button v-tooltip="'Download'" @click="download"><i class="fas fa-download"></i></button>
        </div>
      </template>

      <template
        slot="controls"
        v-if="isTab ('results')"
      >
        <Picker
          v-if="results"
          v-model="selected"
          :tree="tree"
        >
        </Picker>
      </template>

      <template slot="content">
        <Overview
          v-if="isTab ()"
          :replay="replay"
        ></Overview>

        <Loader
          v-model="results"
          v-if="isTab ('results')"
          :url="urlResults"
          :model="ResultSet"
          @ready="onReady"
        >
          <template
            slot="result"
            v-if="
              isTab ('results') &&
              results
            "
          >
            <Results
              :result="results.select (selected)"
              :key="JSON.stringify (selected)"
            ></Results>
          </template>
        </Loader>

        <MMD
          v-if="isTab ('mmd')"
          :replay="replay"
        ></MMD>

        <Chat
          v-if="isTab ('chat')"
          :replay="replay"
        ></Chat>

        <Events
          v-if="isTab ('events')"
          :replay="replay"
        ></Events>
      </template>
    </template>
  </Banner>
</template>

<script>
  import Banner from '@/legacy/components/layout/Banner';
  import Tab from '@/legacy/components/widgets/Tab';
  import Loader from '@/legacy/components/widgets/Loader';
  import Icon from '@/legacy/components/widgets/Icon';
  import Picker from '@/legacy/components/widgets/Picker';
  import Params from '@/legacy/views/game/Params';
  import Overview from '@/legacy/views/game/Overview';
  import Results from '@/legacy/views/game/Results';
  import MMD from '@/legacy/views/game/MMD';
  import Chat from '@/legacy/views/game/Chat';
  import Events from '@/legacy/views/game/Events';
  import ResultSet from '@/legacy/lib//model/ResultSet';
  import Replay from '@/legacy/lib//Replay';
  import { httpBuildQuery, date, filterByKey } from '@/legacy/lib//util';
  import { isTab, metaFactory, capitalize } from '@/legacy/lib//template';
  import Api from '@/legacy/lib//Api';
  import CTS from '@/legacy/lib//Constants';
  import Menu from '@/legacy/lib//model/Menu';
  import PickerTree from '@/legacy/lib//model/PickerTree';

  export default {
    metaInfo () {
      return metaFactory ({
        title: `${this.replay.name}`,
        description: `Replay statistics for ${this.replay.name} played on ${date (this.replay.playedOn)}.`,
        noindex: true
      });
    },

    components: {
      Banner,
      Tab,
      Loader,
      Params,
      Icon,
      Picker,
      Overview,
      Results,
      MMD,
      Chat,
      Events
    },

    data: function () {
      return {
        replay: {},
        results: null,
        menus: [],
        selected: {},
        tree: null,
        ResultSet,
        Replay,
        CTS
      };
    },

    computed: {
      urlReplay () {
        return httpBuildQuery (
          `/replays/${this.$route.params.id}`
        );
      },

      urlResults () {
        return httpBuildQuery (
          `/results/${this.$route.params.id}`
        );
      }
    },

    methods: {
      isTab,

      onReady (res) {
        this.tree = new PickerTree ();

        for (let result of this.results.results) {
          for (let team of result.teams) {
            for (let player of team.players) {
              this.tree.add ({
                round : player.key.round,
                mode  : player.key.mode
              });
            }
          }
        }
      },

      download () {
        window.location.href = Api.getUrl (`/replays/${this.replay.id}/download`);
        this.replay.downloads++;
      }
    }
  };
</script>

<style lang="scss">
  .GameProfile {
    .PageGutter {
      background-color: rgba(0, 0, 0, 0.15);
      background: asset('background/game.jpg') center no-repeat;
      background-size: cover;
      border-bottom: fetch(border faint);
    }

    .PageHeader {
      .Icon {
        color: rgba(var(--tan), 1);
        text-shadow: fetch(shadow text header);
      }
    }
  }
</style>